module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/S3Y0dQ/tc-custom/9781616281427.jpg?1705766094027",
      "alt": "This image is the cover for the book Ice Pops"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ice Pops\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Make these cool creative pops—from fruity favorites to chocolate swirls to liquor-infused grownup desserts!")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" In these pages, you'll find over 40 recipes for frozen delights with tantalizing flavors—summer peach, bright watermelon and lime, rich chocolate swirled with vanilla or layered with raspberries, custard-based cheesecake and caramel, or green tea with pomegranate—which can be made either in an instant ice pop maker or conventional frozen pop molds."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" From simple to inspired, discover an ice pop for any occasion, in this delicious book by a pastry chef and former "), _c('i', [_vm._v("Martha Stewart Living")]), _vm._v(" food editor.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Shelly Kaldunski\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0